<!--二级标签-->
<template>
  <div>
    <bread-crumb></bread-crumb>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
    ></top-bar>

    <base-table
      :tableData="tableData"
      @handleClick="handleClick"
    >
    </base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <modal
      :isShow.sync="dialogShow"
      title="被驳回理由"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @one="handleDialog(false)"
      @update:isShow="handleDialog(false)"
      @two="handleDialogSubmit"
    >
      <div class="base-dialog">
        <el-form :model="formList" :rules="rules">
          <el-form-item
            label="标签名称"
            prop="nameValue"
          >
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="dialogShowLabel"
      title="新增标签"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="addClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="标签名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="标签类型" prop="nameType">
            <el-select v-model="value" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item> -->
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="dialogShowEditLabel"
      title="编辑标签"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="editClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="标签名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="标签类型" prop="nameType">
            <el-select v-model="value" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item> -->
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="moveDialog"
      title="移动"
      :isShowBtn="isShowBtn"
      :btnText="mergeMoveBtnText"
      @clickHandler="moveClickHandler"
      width="800px"
    >
      <ContentLabelCascader
        :labelType="2"
        :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels' }"
        ref="moveSelectedRef"
        :pid="$route.query.labelGroupId"
      />
    </modal>
    <modal
      :isShow.sync="mergeDialog"
      title="合并"
      :isShowBtn="isShowBtn"
      :btnText="mergeMoveBtnText"
      @clickHandler="mergeClickHandler"
      width="800px"
    >
      <ContentLabelCascader
        :labelType="2"
        :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels' }"
        ref="mergeSelectedRef"
        :pid="$route.query.labelGroupId"
      />
    </modal>
    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal
      :isShow.sync="attributeShow"
      title="属性"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="btnTextClickHandler"
    >
      <div class="dialogVal">
        <el-checkbox-group v-model="checkedCities" @change="changeCheck">
          <el-checkbox v-for="item in checkList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
        <el-cascader
          :options="options"
          :props="props"
          collapse-tags
          clearable></el-cascader>
      </div>
    </modal>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import topBar from "@/components/topBar";
import baseTable from "@/components/baseTable";
import ContentLabelCascader from '@/components/select/ContentLabelCascader'
import breadCrumb from "@/components/breadCrumb";
import modal from "@/components/modal";
import {
  saveOrUpdateLabelGroup,
  pageContentLabelGroups,
  deleteLabelGroupById,
  saveOrUpdateContentLabel,
  pageContentLabelsByLabelPid,
  deleteContentLabelById
} from "@/api/man.js"
import {request} from '@/utils/axios';

export default {
  name: "cusThree",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入名称'));
      } else {
        callback();
      }
    };
    return {
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: '标签ID',
            prop: 'id'
          },
          {
            label: '标签名称',
            prop: 'name'
          },
          {
            label: '层级',
            prop: 'labelLevel'
          },
          {
            label: '创建时间',
            prop: 'createTime'
          },
          {
            label: '创建人',
            prop: 'createUser'
          },
        ],
        tableType: 4
      },
      isShowSelect: false,
      // 删除弹框
      deleteDialog: false,
      data: [],
      tableVal: {},
      btnText: ["取消", "确认"],
      // 移动弹框
      moveDialog: false,
      // 合并弹框
      mergeDialog: false,
      mergeMoveBtnText: ["取消", "提交"],
      isShowBtn: [true, true, false],
      nameValue: "",
      dialogShow: false,
      dialogShowLabel: false,
      dialogShowEditLabel: false,
      attributeShow: false, // 属性弹窗
      labelInfos: null,
      formList: {
        nameValue: "",
        nameType: "",
      },
      rules: {
        nameValue: [
          {validator: validatePass, trigger: 'blur'}
        ],
      },
      checkList: [
        {
          id: 1,
          name: '写手端不可见'
        },
        {
          id: 2,
          name: 'C端用户不可见'
        }],
      checkedCities: [],
    };
  },
  components: {
    baseTable,
    topBar,
    breadCrumb,
    modal,
    pagination,
    ContentLabelCascader
  },
  watch: {
    'formList.nameValue'(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: '禁止输入特殊字符',
          type: 'warning'
        });
        this.formList.nameValue = this.$utils.removalSpace(newValue)
      }
    },
  },
  methods: {
    // 获取二级标签
    async pageContentLabelsByLabelPid() {
      let res = await pageContentLabelsByLabelPid({
        tenantId: this.$commonJs.getTenantId(),
        pid: this.$route.query.id,
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize
      })
      this.tableData.tableList.splice(0, this.tableData.tableList.length)
      this.paginationDataProduct.total = res.totalCount
      this.paginationDataProduct.currentPage = res.pageNo
      this.paginationDataProduct.pageSize = res.pageSize
      res.data.map(item => {
        this.tableData.tableList.push(item)
      })
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val
      this.pageContentLabelsByLabelPid()
    },
    handleClick(val) {
      if (val.type === 'edit') {
        this.dialogShowEditLabel = true
        this.formList.nameValue = val.val.name
        this.editLabelName(val)

      } else if (val.type === 'goAdmin') {

        // 跳转三级标签路由
        this.$router.push({
          path: `/customLabel/three`,
          query: {id: val.val.id, pid: this.$route.query.id}
        })
      } else if (val.type === 'delete') {
        this.deleteDialog = true
        this.tableVal = val.val
      } else if (val.type === 'attribute') {
        this.attributeShow = true
        this.tableVal = val.val
      } else if (val.type === 'moveLabel') {
        this.moveDialog = true
        this.tableVal = val.val
      } else if (val.type === 'mergeLabel') {
        this.mergeDialog = true
        this.tableVal = val.val
      }
    },
    deleteClickHandler(val) {
      if (val === 'one') {
        this.deleteDialog = false
      } else if (val === 'two') {
        this.deleteLabelGroupById(this.tableVal)
        this.deleteDialog = false
      }
    },
    deleteLabelGroupById(val) {
      // 删除二级标签
      deleteContentLabelById({
        tenantId: this.$commonJs.getTenantId(),
        id: val.id
      })
        .then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.paginationDataProduct.currentPage = 1;
          this.pageContentLabelsByLabelPid()
        })
        .catch(res => {
          // if(res.data===-1) {
          this.$message.error(
            res.msg
          )
          // }
        })
    },
    // 删除弹框
    addClickHandler(val) {
      if (val === 'one') {
        this.dialogShowLabel = false
      } else if (val === 'two') {
        if (this.formList.nameValue && this.formList.nameValue.trim() != '') {
          // 添加2级标签

          saveOrUpdateContentLabel({
            tenantId: this.$commonJs.getTenantId(),
            // labelGroupId:this.$route.query.id,
            labelGroupId: this.$route.query.labelGroupId,
            pid: this.$route.query.id,
            name: this.formList.nameValue,
            labelLevel: 3
          }).then(res => {
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.dialogShowLabel = false
            this.pageContentLabelsByLabelPid()
            // sessionStorage.setItem('labelGroupId','')
            // this.pageContentLabelGroups()
          }).catch(res => {
            this.$message.error(res.msg);
          })
        } else {
          this.$message.error('请输入标签名称')
        }

      }
    },
    // 合并弹框
    async mergeClickHandler(val) {
      if (val === 'one') {
        this.mergeDialog = false
      } else if (val === 'two') {
        const toLabelIdRef = this.$refs.mergeSelectedRef;
        console.log(this.$refs.mergeSelectedRef.labelValue, 999);
        try {
          var res = await request('health_cmp_mergeContentLabel', {
            tenantId: this.$commonJs.getTenantId(),
            fromLabelId: +this.tableVal.id,
            toLabelId: toLabelIdRef.labelValue[toLabelIdRef.labelValue.length - 1],
          });
          if (res) {
            this.mergeDialog = false
            this.$message.success('操作成功!');
            this.pageContentLabelsByLabelPid()
          }
        } catch(e) {
          console.log(e);
          this.$message.error(e.msg || '操作失败');
        }
      }
    },
    // 移动弹框
    async moveClickHandler(val) {
      if (val === 'one') {
        this.moveDialog = false
      } else if (val === 'two') {
        console.log(this.$refs.moveSelectedRef, 2222);
        try {
          var res = await request('health_cmp_moveContentLabel', {
            tenantId: this.$commonJs.getTenantId(),
            fromLabelId: +this.tableVal.id,
            toLabelId: this.$refs.moveSelectedRef.labelValue[this.$refs.moveSelectedRef.labelValue.length - 1],
          });
          if (res) {
            this.$message.success('操作成功!');
            this.moveDialog = false;
            this.pageContentLabelsByLabelPid()
          }
        } catch(e) {
          console.log(e);
          this.$message.error(e.msg || '操作失败');
        }
      }
    },
    changeCheck(val) {
    },
    // 属性弹窗
    btnTextClickHandler(val) {
      if (val === 'one') {
        this.attributeShow = false
      } else if (val === 'two') {
        this.attributeShow = false
      }
    },
    // 编辑
    editClickHandler(val) {
      if (val === 'one') {
        this.dialogShowEditLabel = false
      } else if (val === 'two') {
        if (this.formList.nameValue && this.formList.nameValue.trim() != '') {
          saveOrUpdateContentLabel({
            tenantId: this.$commonJs.getTenantId(),
            id: this.labelInfos.id,
            labelGroupId:this.$route.query.labelGroupId,
            name: this.formList.nameValue
          }).then(res => {
            this.$message({
              message: '更新成功',
              type: 'success'
            });
            this.dialogShowEditLabel = false
            this.pageContentLabelsByLabelPid()
          }).catch(res => {
            this.$message.error(res.msg);
          })
        } else {
          this.$message.error('请输入标签名称')
        }

      }
    },
    // 更新一级标签
    editLabelName(target) {
      this.labelInfos = target.val


    },
    // 分页
    pageContentLabelGroups() {
      let vm = this
      pageContentLabelGroups({
        tenantId: this.$commonJs.getTenantId(),
        labelType: 1,
        contentBusinessId: '',
        // page:2,
        // pageSize:10
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      })
        .then(res => {
          this.tableData.tableList.splice(0, this.tableData.tableList.length)
          res.data.map(item => {
            this.tableData.tableList.push(item)
          })
          vm.paginationDataProduct.total = res.totalCount
          vm.paginationDataProduct.currentPage = res.pageNo
          vm.paginationDataProduct.pageSize = res.pageSize
        })
    },
    // 新增标签
    clickAddButton() {
      this.formList.nameValue = ''
      this.dialogShowLabel = true
    },
    handleDialog(val) {
      this.dialogShow = val;
    },
    handleDialogLabel(val) {
      this.dialogShowLabel = val;
    },
    handleDialogSubmit() {
      this.handleDialog(false);
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false);
    },
    // 新增
    saveOrUpdateLabelGroup(name) {

      saveOrUpdateLabelGroup({
        labelType: 1,
        name: name,

        tenantId: this.$commonJs.getTenantId(),
      }).then(res => {
        this.pageContentLabelGroups()
      }).catch(error => {
      })
    },
    // 修改标签
    // async editOrUpdateContentLabel() {
    //   let res = await saveOrUpdateContentLabel({

    //   })
    // }
  },
  created() {
    this.pageContentLabelsByLabelPid()
  }
};
</script>

<style lang="scss" scoped>

.dialogVal {
  color: #5F5F6B;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    .el-input {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-form-item__label {
    width: 68px;
    font-weight: bolder;
  }

  .el-input__inner {
    height: 32px;
  }

  // .el-form-item__error {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}
</style>
